import React from "react";
import { useTable, usePagination } from "react-table";
import { Table } from "reactstrap";
import { useTranslation } from "react-i18next";
import "assets/styles/components/table.scss";

function SimpleTable({ columns, data }: any) {
  // const defaultColumn = React.useMemo(
  //   () => ({
  //     minWidth: 50,
  //     width: 100,
  //     maxWidth: 400,
  //   }),
  //   []
  // )

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: data.length },
      // defaultColumn
    },
    usePagination
  );

  return (
    <>
      <div className="table simple-table-style">
        <Table className="" responsive borderless {...getTableProps}>
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr className="fs-6" {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column: any) => (
                  <th
                    {...column.getHeaderProps({
                      style: { minWidth: column.minWidth, width: column.width },
                      className: column.collapse ? "collapse" : "",
                    })}
                    className="table-font-mobile "
                  >
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row: any, i: any) => {
              prepareRow(row);
              return (
                <tr className="fs-6 table-font-mobile" {...row.getRowProps()}>
                  {row.cells.map((cell: any) => {
                    return (
                      <td
                        {...cell.getCellProps({
                          className: cell.column.collapse ? "collapse" : "",
                          style: {
                            minWidth: cell.column.minWidth,
                            width: cell.column.width,
                          },
                        })}
                        className="table-font-mobile "
                      >
                        {cell.render("Cell")}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    </>
  );
}
export default SimpleTable;
